import styled from 'styled-components';

export const SMALLER_HEIGHT = 170;
export const BIGGER_HEIGHT = 300;
const calcHeight = ({ isSmall, isTermsConditionsEnabled }) => {
	return `calc(${isSmall ? SMALLER_HEIGHT : BIGGER_HEIGHT}px ${isTermsConditionsEnabled && ' + 100px'})`;
};

export const Wrapper = styled.div`
	height: ${props => calcHeight(props)};
`;
